import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { serverURL } from "../App";
import axios from "axios";
import VideoPage from "./VideoPage";
import ImagePage from "./ImagePage";
import PdfPage from "./PdfPage";
import Mp3Page from "./Mp3";
import RSVPPage from "./RSVPPage";
import SMSPage from "./SmsPage";
import TextMessage from "./TextMessage";
import WifiPage from "./WifiPage";
import EmailPage from "./Email";

const Home = () => {
  const [qrData, setQrData] = useState({});
  const [loading, setLoading] = useState(true);
  const params = useParams();

  const getQrInfo = async (qr_uuid, signal) => {
    const response = await axios({
      method: "get",
      url: serverURL + "qrCards/qrCodeData/" + qr_uuid,
      signal: signal,
    });
    if (response.data.success) {
      setQrData(response.data.result);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };
  useEffect(() => {
    const controller = new AbortController();
    if (!params.qr_uuid) {
      setLoading(false);
      return console.log("No qr_uuid");
    }
    getQrInfo(params.qr_uuid, controller.signal);
    return () => {
      controller.abort();
    };
  }, [params.qr_uuid]);
  useEffect(() => {
    if (+qrData?.qr_type === 6) {
      window.location.href = qrData?.social_media;
    } else if (+qrData?.qr_type === 1) {
      window.location.href = qrData?.website_url;
    } 
  }, [qrData]);
  return loading ? (
    <div>Loading...</div>
  ) : +qrData?.qr_type === 8 ? (
    <VideoPage data={qrData} />
  ) : +qrData?.qr_type === 12 ? (
    <ImagePage qrData={qrData} />
  ) : +qrData?.qr_type === 10 ? (
    <PdfPage qrData={qrData} />
  ) : +qrData?.qr_type === 4 ? (
    <Mp3Page qrData={qrData} />
  ) : +qrData?.qr_type === 3 || +qrData?.qr_type === 2 ? (
    <RSVPPage qrData={qrData} />
  ) : +qrData?.qr_type === 5 ? (
    <SMSPage qrData={qrData} />
  ) : +qrData?.qr_type === 7 ? (
    <TextMessage qrData={qrData} />
  ) : +qrData?.qr_type === 9 ? (
    <WifiPage qrData={qrData} />
  ) : +qrData?.qr_type === 11 ? (
    <EmailPage qrData={qrData} />
  ) : (
    <div>Invalid QR Code</div>
  );
};

export default Home;
